import { useField } from 'formik';
import { motion } from 'framer-motion';
import { GiCheckMark } from 'react-icons/gi';
import { loginFormVariants } from '../../../constants/animationVariants';

interface IAcademiaCheckboxField {
  title?: string;
  name: string;
  variant?: 'primary' | 'secondary';
  label?: React.ReactNode;
  isRequired?: boolean;
  isReadOnly?: boolean;
}

const AcademiaCheckboxField = ({
  title,
  name,
  label,
  variant = 'primary',
  isRequired,
  isReadOnly,
}: IAcademiaCheckboxField) => {
  // integration of formik hooks here
  const [field, meta] = useField({ name });

  // rendering custom checkbox field component here
  return (
    <div>
      <motion.label
        htmlFor={`${name}-checkbox`}
        initial={{ x: 0 }}
        animate={
          meta.touched && meta.error
            ? {
                x: [0, -100, 0, 100, 0],
                transition: {
                  duration: 0.1,
                  repeat: 2,
                },
              }
            : { x: 0 }
        }
        className={`flex items-start gap-2 w-fit cursor-pointer ${
          !isReadOnly ? 'hover:opacity-70 duration-300' : ''
        }`}
      >
        <div
          title={title}
          className={`flex items-center justify-center size-5 rounded-md border-2 duration-300 mt-1 ${
            field.value
              ? variant === 'primary'
                ? 'bg-legal-dark-blue border-legal-dark-blue'
                : 'bg-base-orange border-base-orange'
              : meta.touched && meta.error
              ? 'bg-transparent : border-base-red'
              : 'bg-transparent border-legal-dark-blue'
          } ${isReadOnly ? 'opacity-60 cursor-not-allowed' : ''}`}
        >
          <motion.div
            variants={loginFormVariants}
            initial='hidden'
            animate={field.value ? 'visible' : 'hidden'}
          >
            <GiCheckMark
              className={`size-3 ${
                variant === 'primary' ? 'text-legal-brown' : 'text-base-white'
              }`}
            />
          </motion.div>
        </div>

        <input
          type='checkbox'
          id={`${name}-checkbox`}
          className='hidden'
          checked={field.value}
          {...field}
          readOnly={isReadOnly}
          disabled={isReadOnly}
        />

        {label && (
          <span
            className={`flex-1 ${
              field.value
                ? 'text-legal-brown'
                : meta.touched && meta.error
                ? 'text-base-red'
                : 'text-legal-dark-blue'
            } font-medium`}
          >
            {label} {isRequired && <span className='text-base-red'>*</span>}
          </span>
        )}
      </motion.label>

      {/* <motion.label
        initial={{ y: -20, opacity: 0, display: 'none' }}
        animate={
          meta.touched && meta.error
            ? { y: 0, opacity: 1, display: 'block' }
            : { y: -20, opacity: 0, transitionEnd: { display: 'none' } }
        }
        htmlFor={`input-${name}`}
        className='block mt-1 text-base-red text-base'
      >
        {meta.error}
      </motion.label> */}
    </div>
  );
};

export default AcademiaCheckboxField;
